import {Controller} from "react-hook-form";

import {Input} from "@/components/ui/input";
import {Tag} from "@/components/ui/Tag";
import {cn} from "@/lib/utils";
import {useTwilioConnectForm} from "@/pages/assistant/quick-setup/hooks/forms/useTwilioConnectForm";

export type TwilioConnectFormFieldsProps = {
  form: ReturnType<typeof useTwilioConnectForm>["form"];
};

export const TwilioConnectFormFields = (
  props: TwilioConnectFormFieldsProps,
) => {
  const {form} = props;

  return (
    <>
      <div className="flex flex-col flex-shrink gap-2">
        <div className="flex items-center justify-between">
          <label
            className="text-label text-sm font-medium"
            htmlFor="twilio-connect-account-sid"
          >
            Account SID
          </label>

          <Tag
            variant="outline"
            className="flex items-center gap-2 shadow-none text-sm font-medium px-1.5"
          >
            <span className={cn("w-2.5 h-2.5 rounded-full bg-gray-300")} />
            Not connected
          </Tag>
        </div>
        <Controller
          name="accountSID"
          control={form.control}
          render={({field: {value, onChange}}) => (
            <Input
              value={value}
              onChange={onChange}
              placeholder="34 digit SID"
              id="twilio-connect-account-sid"
              className="w-full"
            />
          )}
        />
      </div>

      <div className="flex flex-col flex-shrink gap-2">
        <label
          className="text-label text-sm font-medium"
          htmlFor="twilio-connect-auth-token"
        >
          Auth Token
        </label>
        <Controller
          name="authToken"
          control={form.control}
          render={({field: {value, onChange}}) => (
            <Input
              value={value}
              onChange={onChange}
              placeholder="eyJ0eXAiOiJKV1..."
              id="twilio-connect-auth-token"
              className="w-full"
            />
          )}
        />
      </div>
    </>
  );
};
